import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-asset-details-modal',
  templateUrl: './asset-driver-selection-modal.component.html',
  styleUrls: ['./asset-driver-selection-modal.component.scss'],
})
export class AssetDriverSelectionModalComponent implements OnInit {
  public selection: string = 'driver';
  public showSelectionView: boolean = false;
  public isFirstTime: boolean = false;
  public metadata: any;
  public showConfirmation: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AssetDriverSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public dataService: DataService,
    public accessService: AccessService,
    private mixpanelService: MixPanelService
  ) {}

  ngOnInit(): void {
    this.metadata = this.data?.metadata;
    this.showConfirmation = !!this.data?.showConfirmation;

    if (!this.metadata) {
      // First-time user
      this.isFirstTime = true;
      this.showSelectionView = true;
      this.selection = 'driver';
    } else {
      // Returning user
      this.isFirstTime = false;
      this.selection = this.metadata?.driverCentric ? 'driver' : 'asset';
      this.showSelectionView = false;
    }
  }

  saveSelection() {
    const isDriverCentric = this.selection === 'driver';

    if (isDriverCentric) {
      this.mixpanelService.track('toggle-switched/home-page/switche to DriverCentric');
    } else {
      this.mixpanelService.track('toggle-switched/home-page/switche to AssetCentric');
    }

    this.dataService.updateFleetDetails(isDriverCentric).subscribe({
      next: (res) => {
        console.log(res);
      },
    });
    this.dataService.isDriverCentric = isDriverCentric;
    this.accessService.isDriverCentric = isDriverCentric;
    this.dialogRef.close(this.selection);
  }

  cancelSelection() {
    this.dialogRef.close(null);
  }
}
